// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.LedPatternClass + input{\r\n  display: contents !important;\n}\n.detail-dialog.v-dialog:not(.v-dialog--fullscreen) {\r\n    max-height: none !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
